import type { RequestDetails } from '../types';
import {
  REQUEST_TYPE_STANDALONE_FACESHEET,
  REQUEST_TYPE_STANDALONE_RECORD_UPLOAD,
} from '../types/request-services';

/** Facesheet response shape from getStandaloneServiceDetails */
type StandaloneFacesheetDetails = {
  id: string;
  status: string;
  statusGroup: string;
  statusText: string;
  name: string;
  expedited: boolean;
};

/** Record upload response shape from getStandaloneServiceDetails */
type StandaloneRecordUploadDetails = {
  status: string;
  statusGroup: string;
  statusText: string;
  fileName: string;
};

type StandaloneServiceDetails =
  | StandaloneFacesheetDetails
  | StandaloneRecordUploadDetails;

/**
 * Build RequestDetails for the details modal from standalone API response.
 * Returns null if data is missing or requestType is not a known standalone type.
 */
export function buildRequestDetailsFromStandalone(
  data: StandaloneServiceDetails | undefined,
  serviceId: string,
  requestDate: string,
  requestType: string,
): RequestDetails | null {
  if (!data) return null;
  const base = { requestId: serviceId, requestDate };

  if (requestType === REQUEST_TYPE_STANDALONE_FACESHEET) {
    const facesheet = data as StandaloneFacesheetDetails;
    return {
      ...base,
      facesheets: [
        {
          id: facesheet.id,
          status: facesheet.status,
          statusGroup: facesheet.statusGroup,
          statusText: facesheet.statusText,
          name: facesheet.name,
          expedited: facesheet.expedited,
        },
      ],
    };
  }

  if (requestType === REQUEST_TYPE_STANDALONE_RECORD_UPLOAD) {
    const upload = data as StandaloneRecordUploadDetails;
    return {
      ...base,
      recordUpload: {
        status: upload.status,
        statusGroup: upload.statusGroup,
        statusText: upload.statusText,
        fileName: upload.fileName,
      },
    };
  }

  return null;
}
